/** Relationship archetypes on user–organization relations (`basicRoles`). */
export const ORGANIZATION_BASIC_ROLES = {
  MEMBER: 'member',
  NETWORK: 'network',
} as const;

export type OrganizationBasicRole = (typeof ORGANIZATION_BASIC_ROLES)[keyof typeof ORGANIZATION_BASIC_ROLES];

/** Mirrors backend `ORGANIZATION_ROLES` (OSO / relations). */
export const ORGANIZATION_ROLES = {
  OWNER: 'owner',
  ADMIN: 'admin',
  PROCUREMENT: 'procurement',
  MEMBER: 'member',
  CONTENT_MANAGER: 'content_manager',
  EVENT_PLANNER: 'event_planner',
  EVENT_ORGANIZER: 'event_organizer',
} as const;

export type OrganizationRole = (typeof ORGANIZATION_ROLES)[keyof typeof ORGANIZATION_ROLES];

export const ALL_ORGANIZATION_ROLES: OrganizationRole[] = [
  ORGANIZATION_ROLES.OWNER,
  ORGANIZATION_ROLES.ADMIN,
  ORGANIZATION_ROLES.PROCUREMENT,
  ORGANIZATION_ROLES.EVENT_PLANNER,
  ORGANIZATION_ROLES.EVENT_ORGANIZER,
  ORGANIZATION_ROLES.MEMBER,
  ORGANIZATION_ROLES.CONTENT_MANAGER,
];
